import { type CountryCode, formatIncompletePhoneNumber } from 'libphonenumber-js/min';

export const getPhoneNumberText = (
  phoneNumber: string,
  phoneNumberCountryCode: string | null,
  phoneNumberCountryIsdCode: string | null,
) =>
  `(${phoneNumberCountryIsdCode}) ` +
  formatIncompletePhoneNumber(phoneNumber, phoneNumberCountryCode as CountryCode).replace(/^0/, '');
